import { render, staticRenderFns } from "./SuccessEmailValidation.vue?vue&type=template&id=5484f6d5&scoped=true&"
import script from "./SuccessEmailValidation.vue?vue&type=script&lang=js&"
export * from "./SuccessEmailValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5484f6d5",
  null
  
)

export default component.exports